import React from 'react';
import { MessageCircle } from 'lucide-react';
import { motion } from 'framer-motion';
interface CtaButtonProps {
  text: string;
  className?: string;
  variant?: 'solid' | 'outline';
}
export function CtaButton({
  text,
  className = '',
  variant = 'solid'
}: CtaButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center gap-3 px-8 py-4 rounded-sm font-serif text-lg tracking-wide transition-all duration-500 ease-out';
  const variants = {
    solid: 'bg-gradient-to-r from-mystic-gold to-[#E8C275] text-mystic-black hover:shadow-[0_0_20px_rgba(212,162,76,0.4)] hover:scale-[1.02]',
    outline: 'border border-mystic-gold text-mystic-gold hover:bg-mystic-gold/10 hover:shadow-[0_0_15px_rgba(212,162,76,0.2)]'
  };
  return <motion.a href="https://wa.me/message/C5P6OYRK3Y5EP1" target="_blank" rel="noopener noreferrer" className={`${baseStyles} ${variants[variant]} ${className}`} whileHover={{
    y: -2
  }} whileTap={{
    scale: 0.98
  }} data-id="element-214">
      <MessageCircle className="w-5 h-5" data-id="element-215" />
      <span data-id="element-216">{text}</span>
    </motion.a>;
}